<template>
  <figure
    class="achievements-list-item"
    :class="bem('achievements-list-item', { active: achievement.active })"
  >
    <img
      :src="achievement.icon"
      :alt="achievement.title"
      :title="achievement.description"
      width="100"
      height="100"
      class="achievements-list-item__image"
    />
    <figcaption class="achievements-list-item__caption">
      {{ achievement.title }}
    </figcaption>
  </figure>
</template>

<script>
import { bem } from 'src/utils/bem.js';

export default {
  name: 'AchievementsListItem',
  props: {
    achievement: {
      type: Object,
      required: true,
    },
  },
  methods: {
    bem,
  },
};
</script>
